import Layout from "@/modules/wizard/wizard-layout"
import WizardComponent from "@/modules/wizard/component/wizard-component"
import WizardNew from "@/modules/wizard/component/wizard-component-new"
import WizardAll from "@/modules/wizard/component/wizard-all"

const wizardRouter = {
	path: "/wizards",
	name: "wizards",
	component: Layout,
	children: [
		{
			path: "",
			name: "wizards",
			component: WizardAll
		},
		{
			path: "new/:selected_type",
			name: "wizards",
			component: WizardNew
		},
		{
			path: ":id",
			name: "wizards",
			component: WizardComponent
		}
	]
}

export default wizardRouter
